module.exports = __webpack_public_path__ + "media/מעטפה.2f7a144c.mp3";